export default __webpack_public_path__ + "static/media/rhenus-biz.79c27fd1.svg";